import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ResponsivePicture } from "../../../Shared/components/Image";
export const ImagesBlock = (p)=>/*#__PURE__*/ _jsx("section", {
        className: "block block--image-grid container--full gutter--m align--center",
        children: /*#__PURE__*/ _jsx("ul", {
            className: "row block__list",
            children: p.images.map((i, k)=>/*#__PURE__*/ _jsx("li", {
                    className: "block__item col-xs-12 col-sm-6 col-md-4",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "image-block__wrapper",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "image-block__inner",
                            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                imgClassName: "image-block__image",
                                defaultImageUrl: i.imageUrlFallback,
                                cropsPerMedia: [
                                    {
                                        crops: [
                                            {
                                                url: i.imageUrlSmall,
                                                width: 400
                                            },
                                            {
                                                url: i.imageUrl,
                                                width: 800
                                            }
                                        ]
                                    }
                                ],
                                width: 400,
                                height: 280,
                                alt: i.imageAlt
                            })
                        })
                    })
                }, `images-${k}`))
        })
    });
{}